<div class="screen-container">
  <div class="container p-0" *ngIf="_appService && _appService.CoreCommonLiterals !== undefined">
    <div class="map-section" *ngIf="!environment.useOfflineMode">
      <ng-container *ngIf="mapApiReady">
        <google-map
        #googleMap
        height="100%"
        width="100%"
        [center]="{ lat: _latitudeCenter, lng: _longitudeCenter }"
        [zoom]="_zoom"
        [options]="{
          maxZoom: commonMapService?.MaxZoom || 18,
          mapTypeId: 'roadmap',
          gestureHandling: 'greedy',
          zoomControl: true,
          mapTypeControl: true,
          mapTypeControlOptions: googleMapOptions?.mapTypeControlOptions || {
            style: 1,
            position: 1
          },
          streetViewControl: true,
          fullscreenControl: true,
          mapId: googleMapOptions?.mapId || 'custom-map-id'
        }"
        (mapReady)="onMapReady($event)"
        (centerChanged)="onCenterChange($event)"
        (zoomChanged)="onZoomChange($event)"
      >
      </google-map>
    </ng-container>
    <div class="map-section d-flex align-items-center justify-content-center" *ngIf="environment.useOfflineMode">
      <div class="alert alert-warning text-center m-3 w-100">
        <i class="fas fa-map-marked-alt fa-2x mb-3"></i>
        <h4>{{ 'Maps disabled'}}</h4>
        <p>{{'Maps are not available in offline mode.'}}</p>
      </div>
    </div>
  </div>
    <div  class="pl-0 pl-md-4">
      <app-resizable-panel 
      [minWidth]="250" 
      [maxWidth]="maxPanelWidth" 
      [collapsedWidth]="60"
      [initialWidth]="initialPanelWidth"
      [panelId]="'custom-map-panel'"
      [background]="'#f8faf9'"
      [icons]="[{ id: 1, tooltip: _appService.CoreCommonLiterals.RangeBegins, class: 'fa-solid fa-house' }, 
      { id: 2, tooltip: _appService.CoreCommonLiterals.Filter, class: 'fa-solid fa-filter'  },
      { id: 3, tooltip: _appService.CoreCommonLiterals.Setting, class: 'fa-solid fa-gear' }
      ]"
      (action)="onAction($event)">
        <div class="mb-3 h-100">
          <div class="card-block card-body" style="height: 100%; overflow: auto;">
            <div class="form-group" *ngIf="activeIcon == 3">
              <label for="visualizationType">Visualization Type</label>
              <custom-select 
                id="visualizationType"
                name="visualizationType"
                [useParentWidth]="true"
                [(ngModel)]="visualizationType" 
                [sourceList]="visualizationTypeList" 
                [bordered]="true" 
                required
                (select)="onVisualizationTypeChange($event)">
              </custom-select>
            </div>
            <div class="filter-container" *ngIf="activeIcon == 2">
              <div class="form-group" *ngIf="facilitiesList.length && addOnMapping?.Enabled">
                <label for="facilities">{{_appService.CoreCommonLiterals.Facilities}}</label>
                <ss-multiselect-dropdown
                  [texts]="_multiSelectTexts" 
                  [name]="facilities"
                  id="facilities"
                  #facilities{{i}}="ngModel"
                  [settings]="_multiSelectSettings" 
                  [options]="facilitiesList"
                  (onAdded)="applyFilters('facilities')"
                  (onRemoved)="applyFilters('facilities')"
                  [(ngModel)]="facilitiesIds"
                  >
                </ss-multiselect-dropdown>
              </div>
              <div class="form-group">
                <label class="form-label" for="variables">{{_gearService.GearCommonLiterals.Variable}}s</label>
                <ss-multiselect-dropdown
                  [options]="consumptionVariableList"
                  [texts]="_multiSelectTexts"
                  [settings]="_multiSelectSettings"
                 [(ngModel)]="consumptionVariables"
                  name="variables"
                  id="variables">
                </ss-multiselect-dropdown>
              </div>
              <div >
                <form autocomplete="off">
                  <div class="form-group">
                    <form-parameters #formParam [context]="this" [formParameterList]="formParameterList" (formParameterChange)="emitChangeParam($event)" [ngClass]="{'disabled-form': !enableFilter}"></form-parameters>
                    <div class="text-right mt-5">
                      <button (click)="applyFilters('apply');" type="submit" id="btn-applyfilters" class="btn btn-primary btn-block mt-3">
                        {{_appService.CoreCommonLiterals?.Apply}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          <div class="row" *ngIf="activeIcon == 1">
            <div class="col-12 p-0 pr-3" [ngStyle]="{'opacity': clustersFilteredList.length ? '1' : '0'}">
              <div class="card mb-3 search-bar shadow-sm">
                <div class="card-block card-body">
                  <div class="form-group">
                  <i class="fa fa-search"></i>
                    <input id="map-inputsearch" type="text" class="form-control" [placeholder]="_appService.CoreCommonLiterals.ButtonSearch" [(ngModel)]="searchText" (input)="search($event)" customFocus>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12  pl-0" *ngFor="let item of clustersFilteredList"
            [ngClass]="{'active': item.customMap?.EndpointID == _activeMarker}"
            (mouseover)="onCardHover(item)"
            (mouseout)="onCardMouseOut()">
              <div class="card mb-3 shadow-sm card-custom" (click)="onMarkerClick(item.markerData)" style="cursor: pointer;">
                <div class="card-body">
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-2">
                      <i class="fa fa-plug mr-3" style="font-size: 1.5rem; color: var(--primary);" *ngIf="item.customMap?.Points?.TotalFlow || item.customMap?.Points?.TotalActiveConsumption"></i>
                      <i class="fa fa-chart-line mr-3" style="font-size: 1.5rem; color: var(--primary);" *ngIf="item.customMap?.Points?.MetricValue || item.customMap?.Points?.MetricValue === 0 || item.customMap?.Points?.MetricSymbol"></i>
                      <h5 class="card-title mb-0 text-break word-wrap">{{item.customMap?.DisplayText}}</h5>
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="fa fa-building mr-3" style="font-size: 1.5rem; color: var(--primary);"></i>
                      <p class="mb-0">{{item.customMap?.Facility?.Description}} - {{item.customMap?.Facility?.DisplayText}}</p>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent">
                  <div class="d-flex card-footer-icons">
                    <div class="text-success mr-2" *ngIf="item.customMap?.Points?.TotalActiveConsumption">
                      <i class="fa-solid fa-bolt"></i>
                      <span>{{item.customMap?.Points?.TotalActiveConsumption}}</span>
                    </div>
                    <div class="text-info mr-2" *ngIf="item.customMap?.Points?.TotalFlow">
                      <i class="fa-solid fa-water"></i>
                      <span>{{item.customMap?.Points?.TotalFlow}}</span>
                    </div>
                    <div class="text-warning mr-2" *ngIf="item.customMap?.Points?.MetricValue || item.customMap?.Points?.MetricValue === 0 || item.customMap?.Points?.MetricSymbol">
                      <span>Status: {{item.customMap?.Points?.MetricValue}} {{item.customMap?.Points?.MetricSymbol}}</span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!clustersFullList.length || !addOnMapping?.Enabled" class="not-found-message text-center w-100">
              <div class="alert alert-warning w-100" *ngIf="!addOnMapping?.Enabled && addOnMapping?.Visibility === addOnFeatureVisibility.ShowStar">{{_appService.CoreCommonLiterals.AddOnStarVisibilityMessage}}</div>
              <div class="alert alert-info w-100" *ngIf="!addOnMapping?.Enabled && addOnMapping?.Visibility === addOnFeatureVisibility.Visible">{{_appService.CoreCommonLiterals.AddOnDisabledTootilp}}</div>
              <div class="alert w-100" *ngIf="!clustersFullList.length">  
                <i class="fa fa-file-alt fa-2x text-primary"></i>
                <p class="mt-3">{{_appService.CoreCommonLiterals.NoDataFound}}</p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </app-resizable-panel>
    </div>
  </div>
</div>

  
<modal 
#customMapModal
[(successMessage)]="_successMessage"
[(errorMessage)]="_errorMessage" 
*ngIf="_appService && _appService.CoreCommonLiterals !== undefined"
modalClass="modal-lg"
>
<modal-header>{{_appService.CoreCommonLiterals.Details}}</modal-header>
<modal-content>
  <div class="modal-body p-4">
    <div class="section-card mb-4">
      <div class="card rounded-xl shadow-md">
        <div class="card-header bg-light border-0 px-4">
          <div class="d-flex align-items-center">
            <i class="fa-solid fa-microchip fa-2x text-primary mr-4"></i>
            <h4 class="mb-0 font-weight-bold text-dark">{{_appService.CoreCommonLiterals.Device}}</h4>
          </div>
        </div>
        <div class="card-body p-4">
          <div class="row">
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-tag fa-lg text-primary mr-3"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.Description}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="text-truncate" [ngClass]="{'text-muted': !customMapData?.Device?.Description}">
                    {{customMapData?.Device?.Description}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-network-wired fa-lg text-success mr-3"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.Address}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Device?.Address}">
                    {{customMapData?.Device?.Address}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-circle fa-lg mr-3" [ngClass]="{'text-success': customMapData?.Device?.IsOnline, 'text-danger': !customMapData?.Device?.IsOnline}"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.ActionsTriggerTypeState}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="badge" [ngClass]="{'badge-success': customMapData?.Device?.IsOnline, 'badge-danger': !customMapData?.Device?.IsOnline}">
                    {{customMapData?.Device?.IsOnline ? 'Online' : 'Offline'}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-clock fa-lg text-warning mr-3"></i>
                  <span class="font-weight-bold text-truncate mr-2">{{_gearService.GearMonitorLiterals.LastUpdate}}</span>
                </div>
                                 <div class="info-value flex-grow-1">
                   <span [ngClass]="{'text-muted': !customMapData?.Device?.LastActivity}">
                     {{formatDateTimeDT(customMapData?.Device?.LastActivity)}}
                   </span>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-card mb-4">
      <div class="card rounded-xl shadow-md">
        <div class="card-header bg-light border-0 px-4">
          <div class="d-flex align-items-center">
            <i class="fa-solid fa-plug fa-2x text-info mr-4"></i>
            <h4 class="mb-0 font-weight-bold text-dark">{{_appService.CoreCommonLiterals.EndpointWord}}</h4>
          </div>
        </div>
        <div class="card-body p-4">
          <div class="row">
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-tag fa-lg text-primary mr-3"></i>
                  <span class="font-weight-bold text-truncate mr-2">{{_appService.CoreCommonLiterals.Description}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Endpoint?.Description}">
                    {{customMapData?.Endpoint?.Description}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-network-wired fa-lg text-success mr-3"></i>
                  <span class="font-weight-bold text-truncate mr-2">{{_appService.CoreCommonLiterals.Address}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Endpoint?.Address}">
                    {{customMapData?.Endpoint?.Address}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-chart-line fa-lg text-warning mr-3" *ngIf="customMapData?.Data?.MetricDisplayText"></i>
                  <i class="fa-solid fa-water fa-lg text-warning mr-3" *ngIf="customMapData?.Data?.ConsumptionDisplayText"></i>
                  <i class="fa-solid fa-chart-simple fa-lg text-warning mr-3" *ngIf="!customMapData?.Data?.MetricDisplayText && !customMapData?.Data?.ConsumptionDisplayText"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.ActionsTriggerTypeState}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Data?.MetricDisplayText}" *ngIf="customMapData?.Data?.MetricDisplayText">
                    {{customMapData?.Data?.MetricDisplayText}}
                  </span>
                  <span [ngClass]="{'text-muted': !customMapData?.Data?.ConsumptionDisplayText}" *ngIf="customMapData?.Data?.ConsumptionDisplayText || customMapData?.Data?.TotalFlow === 0">
                    {{customMapData?.Data?.ConsumptionDisplayText}}
                  </span>
                  <span [ngClass]="{'text-muted': !customMapData?.Data?.MetricDisplayText && !customMapData?.Data?.ConsumptionDisplayText}" *ngIf="!customMapData?.Data?.MetricDisplayText && !customMapData?.Data?.ConsumptionDisplayText">
                    -
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6"> 
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-clock fa-lg text-info mr-3"></i>
                  <span class="font-weight-bold text-truncate mr-2">{{_gearService?.GearMonitorLiterals?.LastUpdate}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Endpoint?.LastStatusDateTime}">
                    {{formatDateTimeDT(customMapData?.Endpoint?.LastStatusDateTime)}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-card mb-4">
      <div class="card rounded-xl shadow-md">
        <div class="card-header bg-light border-0 px-4">
          <div class="d-flex align-items-center">
            <i class="fa-solid fa-building fa-2x text-warning mr-4"></i>
            <h4 class="mb-0 font-weight-bold text-dark">{{_appService.CoreCommonLiterals.Facility}}</h4>
          </div>
        </div>
        <div class="card-body p-4">
          <div class="row">
            <div class="col-lg-12">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-tag fa-lg text-primary mr-3"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.Description}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Facility?.Description}">
                    {{customMapData?.Facility?.Description}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom" >
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-map-marker-alt fa-lg text-success mr-3"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.Latitude}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Facility?.Location?.Latitude}">
                    {{customMapData?.Facility?.Location?.Latitude}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom" >
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 125px;">
                  <i class="fa-solid fa-map-marker-alt fa-lg text-info mr-3"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.Longitude}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span [ngClass]="{'text-muted': !customMapData?.Facility?.Location?.Longitude}">
                    {{customMapData?.Facility?.Location?.Longitude}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-card" *ngIf="customMapData?.Data?.AlarmStats">
      <div class="card rounded-xl shadow-md">
        <div class="card-header bg-light border-0 px-4">
          <div class="d-flex align-items-center">
            <i class="fa-solid fa-triangle-exclamation fa-2x text-danger mr-4"></i>
            <h4 class="mb-0 font-weight-bold text-dark">{{_appService.CoreCommonLiterals.Alarms}}</h4>
          </div>
        </div>
        <div class="card-body p-4">
          <div class="row">
            <div class="col-lg-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 200px;">
                  <i class="fa-solid fa-exclamation-triangle fa-lg text-danger mr-3"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.HighAlarm}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="badge badge-danger">
                    {{customMapData?.Data?.AlarmStats?.AlarmCount?.HighSeverity || 0}}
                  </span>
                </div>
              </div>
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 200px;">
                  <i class="fa-solid fa-exclamation fa-lg text-warning mr-3"></i>
                  <span class="font-weight-bold"> {{ _appService.CoreCommonLiterals.MediumAlarm }}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="badge badge-warning">
                    {{customMapData?.Data?.AlarmStats?.AlarmCount?.MidSeverity || 0}}
                  </span>
                </div>
              </div>
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 200px;">
                  <i class="fa-solid fa-exclamation fa-lg mr-3" style="color: #ffdd00;"></i>
                  <span class="font-weight-bold">{{ _appService.CoreCommonLiterals.LowAlarm}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="badge badge-warning badge-yellow">
                    {{customMapData?.Data?.AlarmStats?.AlarmCount?.LowSeverity || 0}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 200px;">
                  <i class="fa-solid fa-info-circle fa-lg text-info mr-3"></i>
                  <span class="font-weight-bold">{{_appService.CoreCommonLiterals.InformationAlarm}}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="badge badge-info">
                    {{customMapData?.Data?.AlarmStats?.AlarmCount?.InformationSeverity || 0}}
                  </span>
                </div>
              </div>
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 200px;">
                  <i class="fa-solid fa-minus-circle fa-lg text-muted mr-3"></i>
                  <span class="font-weight-bold"> {{ _appService.CoreCommonLiterals.Normal }}</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="badge badge-light">
                    {{customMapData?.Data?.AlarmStats?.AlarmCount?.WithoutCount || 0}}
                  </span>
                </div>
              </div>
              <div class="info-row d-flex align-items-center py-3 border-bottom">
                <div class="info-label d-flex align-items-center flex-shrink-0" style="width: 200px;">
                  <i class="fa-solid fa-calculator fa-lg text-primary mr-3"></i>
                  <span class="font-weight-bold">Total de Alarmas</span>
                </div>
                <div class="info-value flex-grow-1">
                  <span class="badge badge-primary">
                    {{(customMapData?.Data?.AlarmStats?.AlarmCount?.HighSeverity || 0) + 
                      (customMapData?.Data?.AlarmStats?.AlarmCount?.MidSeverity || 0) + 
                      (customMapData?.Data?.AlarmStats?.AlarmCount?.LowSeverity || 0) + 
                      (customMapData?.Data?.AlarmStats?.AlarmCount?.InformationSeverity || 0)}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal-content>
<modal-footer>
  <a id="map-btn-close" class="btn btn-primary" (click)="_customMapModal.close()">{{_appService.CoreCommonLiterals.ButtonClose}}</a>
</modal-footer>
</modal>